import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { getSessionTimeoutMinutos, clearSessionUser, getSessionUserId, updateSessionTimeout } from './SessionUser';
import AlertDialog from '../components/Lms/Components/Shared/AlertDialog';
import { ENDPOINTS } from '../components/Seguridad/Utils/Endpoints';
import api from '../api';

export const SessionTimeoutHandler = ({ children }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const timerRef = useRef(null);
    const [showTimeoutModal, setShowTimeoutModal] = useState(false);

    // Lista de eventos que resetean el contador
    const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart', 'click'];

    // Sincronizar timeout desde la BD al montar (proteger contra refresh)
    useEffect(() => {
        const userId = getSessionUserId();
        if (userId) {
            api.get(ENDPOINTS.configuracionTimeout(userId))
                .then(res => {
                    const newMins = parseFloat(res.data);
                    updateSessionTimeout(newMins);
                    resetTimer(); // Reiniciar con el nuevo valor
                })
                .catch(err => console.error("[SessionTimeout] Error sincronizando timeout:", err));
        }
    }, []);

    const resetTimer = () => {
        if (timerRef.current) clearTimeout(timerRef.current);

        const timeoutMins = getSessionTimeoutMinutos();
        const timeoutMs = timeoutMins * 60 * 1000;

        timerRef.current = setTimeout(async () => {
            if (getSessionUserId()) {
                console.warn(`[SessionTimeout] !!! SESIÓN EXPIRADA POR INACTIVIDAD (${timeoutMins} min) !!!`);
                
                // Cierre real en el servidor (borra cookies)
                try {
                    await api.post('/Usuarios/logout');
                } catch (e) {
                    console.error("[SessionTimeout] Error en logout remoto:", e);
                }

                clearSessionUser();
                setShowTimeoutModal(true);
            }
        }, timeoutMs);
    };

    useEffect(() => {
        // console.log("[SessionTimeout] Componente montado o ruta cambiada:", location.pathname);

        const publicPages = ['/login', '/', '/forgot-password', '/reset-password'];
        const isPublic = publicPages.includes(location.pathname);

        if (isPublic) {
            if (timerRef.current) {
                // console.log("[SessionTimeout] Página pública detectada. Monitor detenido.");
                clearTimeout(timerRef.current);
                timerRef.current = null;
            }
            return;
        }

        const userId = getSessionUserId();
        if (userId) {
            const mins = getSessionTimeoutMinutos();
            // console.log(`[SessionTimeout] Iniciando monitor para usuario ${userId}. Expira en ${mins} min de inactividad.`);

            // Forzar el inicio del contador
            resetTimer();

            // Agregar listeners
            events.forEach((event) => {
                window.addEventListener(event, resetTimer);
            });
        } else {
            // console.log("[SessionTimeout] No hay usuario en sesión. Monitor en espera.");
        }

        return () => {
            if (timerRef.current) {
                clearTimeout(timerRef.current);
                timerRef.current = null;
            }
            events.forEach((event) => {
                window.removeEventListener(event, resetTimer);
            });
        };
    }, [location.pathname]);

    const handleConfirmTimeout = () => {
        setShowTimeoutModal(false);
        navigate('/login');
    };

    return (
        <>
            {children}
            <AlertDialog
                open={showTimeoutModal}
                onClose={handleConfirmTimeout}
                title="Sesión Expirada"
                message="Tu sesión ha finalizado por falta de actividad. Por favor, inicia sesión nuevamente para continuar."
                buttonText="Entendido"
                variant="warning"
            />
        </>
    );
};
